import { useEffect, useState } from "react";
import { Button, Space, Table, Tag, Modal, Descriptions, Divider } from "antd";
import Layouts from "../../../components/Layouts";
import { useSelector } from "react-redux";

import { getDirectusClient } from "../../../lib/directus";
import { Link } from "react-router-dom";
import { readItems } from "@directus/sdk";
import validarpermiso from "../../../lib/utils";

const Orders = () => {
  const [data, setData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [hasPermissionError, setHasPermissionError] = useState(false);
  const permisos = useSelector((state) => state.permisos);
  const userRoleID = useSelector((state) => state.userdata.role.name);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);

  const showOrderDetails = (record) => {
    setSelectedOrder(record);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedOrder(null);
  };

  const getOrders = async () => {
    if (!validarpermiso("ordenes_decompra", "read", permisos)) {
      setHasPermissionError(true);
      return;
    }

    const directus = await getDirectusClient();
   
    try {
      const orders = await directus.request(
        readItems("ordenes_decompra", {
          fields: "*.*.*",
          limit: -1,
          sort: "-date_created",
          filter: {
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                bodegas:{
                  bodegas_id: {
                  id: { _eq: userBodega }, 
                  },
                }
                 
                }
              : {}),
          },
        })
      );

      const processedOrders = orders.map((order) => ({
        ...order,
        bodegas:
          order.bodegas.length > 0 ? order.bodegas[0].bodegas_id.nombre : null,
        user_created: order.user_created.first_name,
        estado: order.estado.nombre,
      }));

      setData(processedOrders);
      setHasPermissionError(false);
    } catch (error) {
      console.error("Error fetching orders:", error);
      if (
        error.response?.status === 403 ||
        error.message?.includes("permission")
      ) {
        setHasPermissionError(true);
      }
    }
  };
  useEffect(() => {
    if (userBodega) {
      getOrders();
    }
  }, [userBodega, permisos]);
  const columns = [
    {
      title: "Orden",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Factura",
      dataIndex: "numero_factura",
      key: "numero_factura",
    },
    {
      title: "Bodega",
      dataIndex: "bodegas",
      key: "bodegas",
    },
    {
      title: "Responsable",
      dataIndex: "user_created",
      key: "user_created",
    },
    {
      title: "Estado",
      key: "estado",
      dataIndex: "estado",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button type="primary" onClick={() => showOrderDetails(record)}>
            Detalles
          </Button>
        </Space>
      ),
    },
  ];
  return (
    <Layouts>
      <Space direction="vertical" style={{ display: "flex" }}>
        <Button
          disabled={
            !validarpermiso("ordenes_decompra", "create", permisos) ||
            hasPermissionError
          }
        >
          <Link
            to="/orders_create"
            style={{
              color:
                !validarpermiso("ordenes_decompra", "create", permisos) ||
                hasPermissionError
                  ? "rgba(0, 0, 0, 0.25)"
                  : undefined,
            }}
          >
            Agregar nueva orden
          </Link>
        </Button>

        {!hasPermissionError ? (
          <Table columns={columns} dataSource={data} />
        ) : (
          <h3>No tiene permisos para ver órdenes de compra</h3>
        )}
      </Space>

      <Modal
        title="Detalles de la Orden"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={800}
      >
        {selectedOrder && (
          <div>
            <Descriptions bordered>
              <Descriptions.Item label="Número de Factura" span={3}>
                {selectedOrder.numero_factura}
              </Descriptions.Item>
              <Descriptions.Item label="Estado" span={3}>
                {selectedOrder.estado}
              </Descriptions.Item>
              <Descriptions.Item label="Bodega" span={3}>
                {selectedOrder.bodegas}
              </Descriptions.Item>
              <Descriptions.Item label="Proveedor" span={3}>
                {selectedOrder.proveedor?.nombre} (
                {selectedOrder.proveedor?.documento})
              </Descriptions.Item>
            </Descriptions>

            <Divider orientation="left">Productos</Divider>
            <Table
              dataSource={selectedOrder.productos}
              columns={[
                {
                  title: "Producto",
                  dataIndex: ["producto_detalle", "nombre"],
                  key: "nombre",
                },
                {
                  title: "Cantidad",
                  dataIndex: "cantidad",
                  key: "cantidad",
                },
                {
                  title: "Precio compra",
                  dataIndex: "precio_compra",
                  key: "precio_compra",
                },
                {
                  title: "Precio final",
                  dataIndex: "precio_uni_final",
                  key: "precio_uni_final",
                },
              ]}
              pagination={false}
            />
          </div>
        )}
      </Modal>
    </Layouts>
  );
};
export default Orders;
